import React from 'react'
import { LoadMoreProps } from '../../types'

export const LoadMoreComponent: React.FC<LoadMoreProps> = props => {
    return (
        <div className="art-list__more">
            {props.moreToLoad &&
                <button className="btn--black center" onClick={props.onClick}>
                    {props.loadMoreLabel}
                </button>
            }
        </div>
    )
}
